import { findGameByName } from "../../data/dummyGames";
import { scorePost } from "../../types/Score";
import { accountStat } from "./gameSlice";

export async function getGame(name: String) {
  return Promise.resolve(findGameByName(String(name)));
}

export async function postScore(_scorePost: scorePost) {
  return Promise.resolve({ ok: true });
}

export const getStat = async (_stat: string) => {
  return Promise.resolve([]);
};

export const updateAccountStat = async (
  stat: accountStat,
  value: object
) => {
  return Promise.resolve({
    ...stat,
    ...(value as object),
  } as accountStat);
};

export const getGameAchievements = async (_gameID: string) => {
  return Promise.resolve([]);
};

export const updateAccountAchievement = async (_accAchievementID: number) => {
  return Promise.resolve({ ok: true });
};
